/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcademyLiveListParams,
  AcademyLiveSessionsListParams,
  AcademyLiveSettingsListParams,
  AttendanceRequest,
  LearnerLiveSession,
  LiveRegistration,
  LiveSession,
  LiveSessionRequest,
  LiveSettings,
  LiveUnregistered,
  PaginatedLiveSessionList,
  PaginatedLiveSettingsList,
  PatchedLiveSessionRequest,
  PatchedLiveSettingsRequest
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyLiveListResponse200 = {
  data: LearnerLiveSession[]
  status: 200
}
    
export type academyLiveListResponseSuccess = (academyLiveListResponse200) & {
  headers: Headers;
};
;

export type academyLiveListResponse = (academyLiveListResponseSuccess)

export const getAcademyLiveListUrl = (params?: AcademyLiveListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/live/?${stringifiedParams}` : `/api/v1/academy/live/`
}

export const academyLiveList = async (params?: AcademyLiveListParams, options?: RequestInit): Promise<academyLiveListResponse> => {
  
  return apiFetch<academyLiveListResponse>(getAcademyLiveListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLiveListQueryKey = (params?: AcademyLiveListParams,) => {
    return [
    `/api/v1/academy/live/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyLiveListQueryOptions = <TData = Awaited<ReturnType<typeof academyLiveList>>, TError = unknown>(params?: AcademyLiveListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLiveListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLiveList>>> = ({ signal }) => academyLiveList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLiveList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLiveListQueryResult = NonNullable<Awaited<ReturnType<typeof academyLiveList>>>
export type AcademyLiveListQueryError = unknown


export function useAcademyLiveList<TData = Awaited<ReturnType<typeof academyLiveList>>, TError = unknown>(
 params: undefined |  AcademyLiveListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLiveList>>,
          TError,
          Awaited<ReturnType<typeof academyLiveList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLiveList<TData = Awaited<ReturnType<typeof academyLiveList>>, TError = unknown>(
 params?: AcademyLiveListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLiveList>>,
          TError,
          Awaited<ReturnType<typeof academyLiveList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLiveList<TData = Awaited<ReturnType<typeof academyLiveList>>, TError = unknown>(
 params?: AcademyLiveListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLiveList<TData = Awaited<ReturnType<typeof academyLiveList>>, TError = unknown>(
 params?: AcademyLiveListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLiveListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyLiveSessionsListResponse200 = {
  data: PaginatedLiveSessionList
  status: 200
}
    
export type academyLiveSessionsListResponseSuccess = (academyLiveSessionsListResponse200) & {
  headers: Headers;
};
;

export type academyLiveSessionsListResponse = (academyLiveSessionsListResponseSuccess)

export const getAcademyLiveSessionsListUrl = (params?: AcademyLiveSessionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/live-sessions/?${stringifiedParams}` : `/api/v1/academy/live-sessions/`
}

export const academyLiveSessionsList = async (params?: AcademyLiveSessionsListParams, options?: RequestInit): Promise<academyLiveSessionsListResponse> => {
  
  return apiFetch<academyLiveSessionsListResponse>(getAcademyLiveSessionsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLiveSessionsListQueryKey = (params?: AcademyLiveSessionsListParams,) => {
    return [
    `/api/v1/academy/live-sessions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyLiveSessionsListQueryOptions = <TData = Awaited<ReturnType<typeof academyLiveSessionsList>>, TError = unknown>(params?: AcademyLiveSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLiveSessionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLiveSessionsList>>> = ({ signal }) => academyLiveSessionsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLiveSessionsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyLiveSessionsList>>>
export type AcademyLiveSessionsListQueryError = unknown


export function useAcademyLiveSessionsList<TData = Awaited<ReturnType<typeof academyLiveSessionsList>>, TError = unknown>(
 params: undefined |  AcademyLiveSessionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLiveSessionsList>>,
          TError,
          Awaited<ReturnType<typeof academyLiveSessionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLiveSessionsList<TData = Awaited<ReturnType<typeof academyLiveSessionsList>>, TError = unknown>(
 params?: AcademyLiveSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLiveSessionsList>>,
          TError,
          Awaited<ReturnType<typeof academyLiveSessionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLiveSessionsList<TData = Awaited<ReturnType<typeof academyLiveSessionsList>>, TError = unknown>(
 params?: AcademyLiveSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLiveSessionsList<TData = Awaited<ReturnType<typeof academyLiveSessionsList>>, TError = unknown>(
 params?: AcademyLiveSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLiveSessionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyLiveSessionsCreateResponse201 = {
  data: LiveSession
  status: 201
}
    
export type academyLiveSessionsCreateResponseSuccess = (academyLiveSessionsCreateResponse201) & {
  headers: Headers;
};
;

export type academyLiveSessionsCreateResponse = (academyLiveSessionsCreateResponseSuccess)

export const getAcademyLiveSessionsCreateUrl = () => {


  

  return `/api/v1/academy/live-sessions/`
}

export const academyLiveSessionsCreate = async (liveSessionRequest: LiveSessionRequest, options?: RequestInit): Promise<academyLiveSessionsCreateResponse> => {
  
  return apiFetch<academyLiveSessionsCreateResponse>(getAcademyLiveSessionsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      liveSessionRequest,)
  }
);}




export const getAcademyLiveSessionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLiveSessionsCreate>>, TError,{data: LiveSessionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyLiveSessionsCreate>>, TError,{data: LiveSessionRequest}, TContext> => {

const mutationKey = ['academyLiveSessionsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyLiveSessionsCreate>>, {data: LiveSessionRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyLiveSessionsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyLiveSessionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyLiveSessionsCreate>>>
    export type AcademyLiveSessionsCreateMutationBody = LiveSessionRequest
    export type AcademyLiveSessionsCreateMutationError = unknown

    export const useAcademyLiveSessionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLiveSessionsCreate>>, TError,{data: LiveSessionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyLiveSessionsCreate>>,
        TError,
        {data: LiveSessionRequest},
        TContext
      > => {

      const mutationOptions = getAcademyLiveSessionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyLiveSessionsRetrieveResponse200 = {
  data: LiveSession
  status: 200
}
    
export type academyLiveSessionsRetrieveResponseSuccess = (academyLiveSessionsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyLiveSessionsRetrieveResponse = (academyLiveSessionsRetrieveResponseSuccess)

export const getAcademyLiveSessionsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/live-sessions/${id}/`
}

export const academyLiveSessionsRetrieve = async (id: string, options?: RequestInit): Promise<academyLiveSessionsRetrieveResponse> => {
  
  return apiFetch<academyLiveSessionsRetrieveResponse>(getAcademyLiveSessionsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLiveSessionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/live-sessions/${id}/`
    ] as const;
    }

    
export const getAcademyLiveSessionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyLiveSessionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLiveSessionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLiveSessionsRetrieve>>> = ({ signal }) => academyLiveSessionsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLiveSessionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyLiveSessionsRetrieve>>>
export type AcademyLiveSessionsRetrieveQueryError = unknown


export function useAcademyLiveSessionsRetrieve<TData = Awaited<ReturnType<typeof academyLiveSessionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLiveSessionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyLiveSessionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLiveSessionsRetrieve<TData = Awaited<ReturnType<typeof academyLiveSessionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLiveSessionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyLiveSessionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLiveSessionsRetrieve<TData = Awaited<ReturnType<typeof academyLiveSessionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLiveSessionsRetrieve<TData = Awaited<ReturnType<typeof academyLiveSessionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLiveSessionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyLiveSessionsPartialUpdateResponse200 = {
  data: LiveSession
  status: 200
}
    
export type academyLiveSessionsPartialUpdateResponseSuccess = (academyLiveSessionsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type academyLiveSessionsPartialUpdateResponse = (academyLiveSessionsPartialUpdateResponseSuccess)

export const getAcademyLiveSessionsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/academy/live-sessions/${id}/`
}

export const academyLiveSessionsPartialUpdate = async (id: string,
    patchedLiveSessionRequest: PatchedLiveSessionRequest, options?: RequestInit): Promise<academyLiveSessionsPartialUpdateResponse> => {
  
  return apiFetch<academyLiveSessionsPartialUpdateResponse>(getAcademyLiveSessionsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedLiveSessionRequest,)
  }
);}




export const getAcademyLiveSessionsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLiveSessionsPartialUpdate>>, TError,{id: string;data: PatchedLiveSessionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyLiveSessionsPartialUpdate>>, TError,{id: string;data: PatchedLiveSessionRequest}, TContext> => {

const mutationKey = ['academyLiveSessionsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyLiveSessionsPartialUpdate>>, {id: string;data: PatchedLiveSessionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyLiveSessionsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyLiveSessionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof academyLiveSessionsPartialUpdate>>>
    export type AcademyLiveSessionsPartialUpdateMutationBody = PatchedLiveSessionRequest
    export type AcademyLiveSessionsPartialUpdateMutationError = unknown

    export const useAcademyLiveSessionsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLiveSessionsPartialUpdate>>, TError,{id: string;data: PatchedLiveSessionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyLiveSessionsPartialUpdate>>,
        TError,
        {id: string;data: PatchedLiveSessionRequest},
        TContext
      > => {

      const mutationOptions = getAcademyLiveSessionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyLiveSessionsAttendanceCreateResponse200 = {
  data: LiveRegistration
  status: 200
}
    
export type academyLiveSessionsAttendanceCreateResponseSuccess = (academyLiveSessionsAttendanceCreateResponse200) & {
  headers: Headers;
};
;

export type academyLiveSessionsAttendanceCreateResponse = (academyLiveSessionsAttendanceCreateResponseSuccess)

export const getAcademyLiveSessionsAttendanceCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/live-sessions/${id}/attendance/`
}

export const academyLiveSessionsAttendanceCreate = async (id: string,
    attendanceRequest: AttendanceRequest, options?: RequestInit): Promise<academyLiveSessionsAttendanceCreateResponse> => {
  
  return apiFetch<academyLiveSessionsAttendanceCreateResponse>(getAcademyLiveSessionsAttendanceCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      attendanceRequest,)
  }
);}




export const getAcademyLiveSessionsAttendanceCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLiveSessionsAttendanceCreate>>, TError,{id: string;data: AttendanceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyLiveSessionsAttendanceCreate>>, TError,{id: string;data: AttendanceRequest}, TContext> => {

const mutationKey = ['academyLiveSessionsAttendanceCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyLiveSessionsAttendanceCreate>>, {id: string;data: AttendanceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyLiveSessionsAttendanceCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyLiveSessionsAttendanceCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyLiveSessionsAttendanceCreate>>>
    export type AcademyLiveSessionsAttendanceCreateMutationBody = AttendanceRequest
    export type AcademyLiveSessionsAttendanceCreateMutationError = unknown

    export const useAcademyLiveSessionsAttendanceCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLiveSessionsAttendanceCreate>>, TError,{id: string;data: AttendanceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyLiveSessionsAttendanceCreate>>,
        TError,
        {id: string;data: AttendanceRequest},
        TContext
      > => {

      const mutationOptions = getAcademyLiveSessionsAttendanceCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyLiveSessionsRegenerateLinkCreateResponse202 = {
  data: LiveSession
  status: 202
}
    
export type academyLiveSessionsRegenerateLinkCreateResponseSuccess = (academyLiveSessionsRegenerateLinkCreateResponse202) & {
  headers: Headers;
};
;

export type academyLiveSessionsRegenerateLinkCreateResponse = (academyLiveSessionsRegenerateLinkCreateResponseSuccess)

export const getAcademyLiveSessionsRegenerateLinkCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/live-sessions/${id}/regenerate-link/`
}

export const academyLiveSessionsRegenerateLinkCreate = async (id: string, options?: RequestInit): Promise<academyLiveSessionsRegenerateLinkCreateResponse> => {
  
  return apiFetch<academyLiveSessionsRegenerateLinkCreateResponse>(getAcademyLiveSessionsRegenerateLinkCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyLiveSessionsRegenerateLinkCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLiveSessionsRegenerateLinkCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyLiveSessionsRegenerateLinkCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyLiveSessionsRegenerateLinkCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyLiveSessionsRegenerateLinkCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyLiveSessionsRegenerateLinkCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyLiveSessionsRegenerateLinkCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyLiveSessionsRegenerateLinkCreate>>>
    
    export type AcademyLiveSessionsRegenerateLinkCreateMutationError = unknown

    export const useAcademyLiveSessionsRegenerateLinkCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLiveSessionsRegenerateLinkCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyLiveSessionsRegenerateLinkCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyLiveSessionsRegenerateLinkCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyLiveSessionsRegistrationsListResponse200 = {
  data: LiveRegistration[]
  status: 200
}
    
export type academyLiveSessionsRegistrationsListResponseSuccess = (academyLiveSessionsRegistrationsListResponse200) & {
  headers: Headers;
};
;

export type academyLiveSessionsRegistrationsListResponse = (academyLiveSessionsRegistrationsListResponseSuccess)

export const getAcademyLiveSessionsRegistrationsListUrl = (id: string,) => {


  

  return `/api/v1/academy/live-sessions/${id}/registrations/`
}

export const academyLiveSessionsRegistrationsList = async (id: string, options?: RequestInit): Promise<academyLiveSessionsRegistrationsListResponse> => {
  
  return apiFetch<academyLiveSessionsRegistrationsListResponse>(getAcademyLiveSessionsRegistrationsListUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLiveSessionsRegistrationsListQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/live-sessions/${id}/registrations/`
    ] as const;
    }

    
export const getAcademyLiveSessionsRegistrationsListQueryOptions = <TData = Awaited<ReturnType<typeof academyLiveSessionsRegistrationsList>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsRegistrationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLiveSessionsRegistrationsListQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLiveSessionsRegistrationsList>>> = ({ signal }) => academyLiveSessionsRegistrationsList(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsRegistrationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLiveSessionsRegistrationsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyLiveSessionsRegistrationsList>>>
export type AcademyLiveSessionsRegistrationsListQueryError = unknown


export function useAcademyLiveSessionsRegistrationsList<TData = Awaited<ReturnType<typeof academyLiveSessionsRegistrationsList>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsRegistrationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLiveSessionsRegistrationsList>>,
          TError,
          Awaited<ReturnType<typeof academyLiveSessionsRegistrationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLiveSessionsRegistrationsList<TData = Awaited<ReturnType<typeof academyLiveSessionsRegistrationsList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsRegistrationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLiveSessionsRegistrationsList>>,
          TError,
          Awaited<ReturnType<typeof academyLiveSessionsRegistrationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLiveSessionsRegistrationsList<TData = Awaited<ReturnType<typeof academyLiveSessionsRegistrationsList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsRegistrationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLiveSessionsRegistrationsList<TData = Awaited<ReturnType<typeof academyLiveSessionsRegistrationsList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSessionsRegistrationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLiveSessionsRegistrationsListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyLiveSettingsListResponse200 = {
  data: PaginatedLiveSettingsList
  status: 200
}
    
export type academyLiveSettingsListResponseSuccess = (academyLiveSettingsListResponse200) & {
  headers: Headers;
};
;

export type academyLiveSettingsListResponse = (academyLiveSettingsListResponseSuccess)

export const getAcademyLiveSettingsListUrl = (params?: AcademyLiveSettingsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/live-settings/?${stringifiedParams}` : `/api/v1/academy/live-settings/`
}

export const academyLiveSettingsList = async (params?: AcademyLiveSettingsListParams, options?: RequestInit): Promise<academyLiveSettingsListResponse> => {
  
  return apiFetch<academyLiveSettingsListResponse>(getAcademyLiveSettingsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLiveSettingsListQueryKey = (params?: AcademyLiveSettingsListParams,) => {
    return [
    `/api/v1/academy/live-settings/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyLiveSettingsListQueryOptions = <TData = Awaited<ReturnType<typeof academyLiveSettingsList>>, TError = unknown>(params?: AcademyLiveSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLiveSettingsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLiveSettingsList>>> = ({ signal }) => academyLiveSettingsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLiveSettingsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLiveSettingsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyLiveSettingsList>>>
export type AcademyLiveSettingsListQueryError = unknown


export function useAcademyLiveSettingsList<TData = Awaited<ReturnType<typeof academyLiveSettingsList>>, TError = unknown>(
 params: undefined |  AcademyLiveSettingsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSettingsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLiveSettingsList>>,
          TError,
          Awaited<ReturnType<typeof academyLiveSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLiveSettingsList<TData = Awaited<ReturnType<typeof academyLiveSettingsList>>, TError = unknown>(
 params?: AcademyLiveSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSettingsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLiveSettingsList>>,
          TError,
          Awaited<ReturnType<typeof academyLiveSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLiveSettingsList<TData = Awaited<ReturnType<typeof academyLiveSettingsList>>, TError = unknown>(
 params?: AcademyLiveSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLiveSettingsList<TData = Awaited<ReturnType<typeof academyLiveSettingsList>>, TError = unknown>(
 params?: AcademyLiveSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLiveSettingsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyLiveSettingsRetrieveResponse200 = {
  data: LiveSettings
  status: 200
}
    
export type academyLiveSettingsRetrieveResponseSuccess = (academyLiveSettingsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyLiveSettingsRetrieveResponse = (academyLiveSettingsRetrieveResponseSuccess)

export const getAcademyLiveSettingsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/live-settings/${id}/`
}

export const academyLiveSettingsRetrieve = async (id: string, options?: RequestInit): Promise<academyLiveSettingsRetrieveResponse> => {
  
  return apiFetch<academyLiveSettingsRetrieveResponse>(getAcademyLiveSettingsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLiveSettingsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/live-settings/${id}/`
    ] as const;
    }

    
export const getAcademyLiveSettingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyLiveSettingsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLiveSettingsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLiveSettingsRetrieve>>> = ({ signal }) => academyLiveSettingsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLiveSettingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLiveSettingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyLiveSettingsRetrieve>>>
export type AcademyLiveSettingsRetrieveQueryError = unknown


export function useAcademyLiveSettingsRetrieve<TData = Awaited<ReturnType<typeof academyLiveSettingsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSettingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLiveSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyLiveSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLiveSettingsRetrieve<TData = Awaited<ReturnType<typeof academyLiveSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSettingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLiveSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyLiveSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLiveSettingsRetrieve<TData = Awaited<ReturnType<typeof academyLiveSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLiveSettingsRetrieve<TData = Awaited<ReturnType<typeof academyLiveSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLiveSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLiveSettingsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyLiveSettingsPartialUpdateResponse200 = {
  data: LiveSettings
  status: 200
}
    
export type academyLiveSettingsPartialUpdateResponseSuccess = (academyLiveSettingsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type academyLiveSettingsPartialUpdateResponse = (academyLiveSettingsPartialUpdateResponseSuccess)

export const getAcademyLiveSettingsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/academy/live-settings/${id}/`
}

export const academyLiveSettingsPartialUpdate = async (id: string,
    patchedLiveSettingsRequest: PatchedLiveSettingsRequest, options?: RequestInit): Promise<academyLiveSettingsPartialUpdateResponse> => {
  
  return apiFetch<academyLiveSettingsPartialUpdateResponse>(getAcademyLiveSettingsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedLiveSettingsRequest,)
  }
);}




export const getAcademyLiveSettingsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLiveSettingsPartialUpdate>>, TError,{id: string;data: PatchedLiveSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyLiveSettingsPartialUpdate>>, TError,{id: string;data: PatchedLiveSettingsRequest}, TContext> => {

const mutationKey = ['academyLiveSettingsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyLiveSettingsPartialUpdate>>, {id: string;data: PatchedLiveSettingsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyLiveSettingsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyLiveSettingsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof academyLiveSettingsPartialUpdate>>>
    export type AcademyLiveSettingsPartialUpdateMutationBody = PatchedLiveSettingsRequest
    export type AcademyLiveSettingsPartialUpdateMutationError = unknown

    export const useAcademyLiveSettingsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLiveSettingsPartialUpdate>>, TError,{id: string;data: PatchedLiveSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyLiveSettingsPartialUpdate>>,
        TError,
        {id: string;data: PatchedLiveSettingsRequest},
        TContext
      > => {

      const mutationOptions = getAcademyLiveSettingsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyLiveRegisterCreateResponse201 = {
  data: LearnerLiveSession
  status: 201
}
    
export type academyLiveRegisterCreateResponseSuccess = (academyLiveRegisterCreateResponse201) & {
  headers: Headers;
};
;

export type academyLiveRegisterCreateResponse = (academyLiveRegisterCreateResponseSuccess)

export const getAcademyLiveRegisterCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/live/${id}/register/`
}

export const academyLiveRegisterCreate = async (id: string, options?: RequestInit): Promise<academyLiveRegisterCreateResponse> => {
  
  return apiFetch<academyLiveRegisterCreateResponse>(getAcademyLiveRegisterCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyLiveRegisterCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLiveRegisterCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyLiveRegisterCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyLiveRegisterCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyLiveRegisterCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyLiveRegisterCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyLiveRegisterCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyLiveRegisterCreate>>>
    
    export type AcademyLiveRegisterCreateMutationError = unknown

    export const useAcademyLiveRegisterCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLiveRegisterCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyLiveRegisterCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyLiveRegisterCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyLiveRegisterDestroyResponse200 = {
  data: LiveUnregistered
  status: 200
}
    
export type academyLiveRegisterDestroyResponseSuccess = (academyLiveRegisterDestroyResponse200) & {
  headers: Headers;
};
;

export type academyLiveRegisterDestroyResponse = (academyLiveRegisterDestroyResponseSuccess)

export const getAcademyLiveRegisterDestroyUrl = (id: string,) => {


  

  return `/api/v1/academy/live/${id}/register/`
}

export const academyLiveRegisterDestroy = async (id: string, options?: RequestInit): Promise<academyLiveRegisterDestroyResponse> => {
  
  return apiFetch<academyLiveRegisterDestroyResponse>(getAcademyLiveRegisterDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getAcademyLiveRegisterDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLiveRegisterDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyLiveRegisterDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyLiveRegisterDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyLiveRegisterDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyLiveRegisterDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyLiveRegisterDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof academyLiveRegisterDestroy>>>
    
    export type AcademyLiveRegisterDestroyMutationError = unknown

    export const useAcademyLiveRegisterDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLiveRegisterDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyLiveRegisterDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyLiveRegisterDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    